import { alpha, Box, Button, darken, lighten, Paper, styled, } from '@mui/material';
import { BaseCardLabel } from 'console/shared/styles/mixins/base-card';
export const BottomNavigation = styled(Paper)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    bottom: 0,
    zIndex: 10,
    backgroundColor: darken(theme.palette.background.default, 0.05),
    borderRadius: 0,
    boxShadow: 'none',
}));
const getTabColor = (theme, selected) => {
    const { palette } = theme;
    if (palette.mode === 'dark') {
        if (selected) {
            return lighten(palette.primary.main, 0.1);
        }
        return alpha(palette.primary.main, 0.6);
    }
    if (selected) {
        return palette.primary.main;
    }
    return darken(palette.secondary.main, 0.1);
};
export const SmallNavigationTabs = styled(Box)(({ theme, tab_width, current_tab_index }) => ({
    position: 'relative',
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    padding: '4px 0px',
    width: '100%',
    overflow: 'auto',
    '&::after': {
        content: '""',
        position: 'absolute',
        height: 4,
        width: tab_width / 2,
        top: 0,
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
        transform: `translateX(${tab_width * current_tab_index + tab_width / 4}px)`,
        transition: 'all 0.7s ease-in-out',
    },
}));
export const MorePopupContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: '4px',
    overflow: 'auto',
    backgroundColor: darken(theme.palette.background.default, 0.05),
}));
export const SmallNavigationTab = styled(Button)(({ theme, selected, width }) => ({
    color: getTabColor(theme, selected),
    display: 'grid',
    gridTemplateRows: '1fr 0.8fr',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    width,
    height: '100%',
    flexGrow: 1,
    flexShrink: 1,
    cursor: 'pointer',
    transition: 'all 0.2s linear',
    fontSize: '2rem',
    rowGap: 4,
    position: 'relative',
    boxSizing: 'border-box',
}));
export const MediumNavigationTab = styled(Button)(({ theme, selected }) => ({
    color: getTabColor(theme, selected),
    display: 'grid',
    gridTemplateRows: 'repeat(2, 1fr)',
    alignItems: 'center',
    padding: 8,
    transition: 'all 0.2s linear',
    cursor: 'pointer',
    fontSize: '2.5rem',
    maxWidth: 150,
    rowGap: 4,
    height: '100%',
}));
export const MediumNavigationTabs = styled(Box)(({ theme }) => ({
    padding: '8px 16px',
    width: '100%',
    minHeight: 65,
    display: 'flex',
    columnGap: 4,
    overflowX: 'auto',
    background: theme.palette.background.default,
    overflowY: 'hidden',
}));
export const TabLabel = styled(BaseCardLabel)({
    color: 'inherit',
    textTransform: 'capitalize',
});
export const TabIcon = styled(Box)({
    display: 'flex',
    alignSelf: 'flex-end',
    alignItems: 'center',
    justifyContent: 'center',
});
